import { ReactNode } from "react";
import { AppShell, Button, Group, Alert, Stack } from "@mantine/core";
import { LOGO_BACKGROUND_RGB } from "../Settings";
import { Link } from "react-router-dom";
import { useUser } from "../auth/hooks";
import { useGlobalContext } from "../context/globalContext";

type AppShellComponentProps = {
  navItems?: ReactNode;
  children: ReactNode;
};

export const HEADER_HEIGHT_PX = 75;

export default function AppShellComponent({
  navItems,
  children,
}: AppShellComponentProps) {
  const { socketConnected } = useGlobalContext();

  const user = useUser();

  return (
    <AppShell
      header={{
        height: !socketConnected
          ? `${HEADER_HEIGHT_PX * 2}px`
          : `${HEADER_HEIGHT_PX}px`,
      }}
      navbar={{
        width: 300,
        breakpoint: "sm",
        collapsed: { desktop: true, mobile: true },
      }}
      padding="md"
    >
      {user ? (
        <Stack>
          <AppShell.Header
            h={`${HEADER_HEIGHT_PX}px`}
            style={{
              backgroundColor: LOGO_BACKGROUND_RGB,
            }}
          >
            <Group
              mx={{ base: "xs", sm: "xl" }}
              h="100%"
              justify="space-between"
              wrap="nowrap"
            >
              <Link to="/">
                <Group gap={0} wrap="nowrap">
                  <img
                    src="/ges-health-logo.png"
                    alt=""
                    style={{
                      width: "120px",
                      height: "60px",
                      objectFit: "cover",
                      objectPosition: "0px -5px",
                    }}
                  ></img>
                </Group>
              </Link>

              {navItems}
            </Group>
          </AppShell.Header>

          {socketConnected === false && (
            <Alert
              color="red"
              variant="filled"
              style={{
                position: "absolute",
                top: `${HEADER_HEIGHT_PX}px`,
                width: "100%",
              }}
            >
              <Group justify="center">
                Cannot establish live connection with server{" "}
                <Button
                  color="white"
                  variant="outline"
                  onClick={() => window.location.reload()}
                >
                  Reload
                </Button>
              </Group>
            </Alert>
          )}
        </Stack>
      ) : (
        <></>
      )}

      <AppShell.Main
        style={{
          backgroundColor: `${
            user ? "rgb(237, 237, 237)" : LOGO_BACKGROUND_RGB
          }`,
        }}
      >
        {children}
      </AppShell.Main>
    </AppShell>
  );
}
